import { render, staticRenderFns } from "./distcommission-add-or-update.vue?vue&type=template&id=2518a5c8&"
import script from "./distcommission-add-or-update.vue?vue&type=script&lang=js&"
export * from "./distcommission-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports